<template>
  
  <div style="padding: 3% 8% 3% 8% !important;">
    <sdPageHeader title="Privacy Policy">
      <template v-slot:subTitle>
        
        <a-button
          size="default"
          type="text"
          style="
            border: none;
            vertical-align: middle;
            transform: rotateZ(270deg);
          "
        >
          <span>
            <sdFeatherIcons
              style="line-height: 0; color: black !important"
              type="bar-chart"
              size="18"
          /></span>
        </a-button>
      </template>
    </sdPageHeader>
    <Main>
      <div>
      <section class="elementor-section elementor-top-section elementor-element elementor-element-59fe108 elementor-section-stretched elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="59fe108" data-element_type="section" data-settings="{&quot;stretch_section&quot;:&quot;section-stretched&quot;}">
            <div class="elementor-container elementor-column-gap-default">
              <div class="elementor-row">
          <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-12bc233" data-id="12bc233" data-element_type="column">
      <div class="elementor-column-wrap elementor-element-populated">
              <div class="elementor-widget-wrap">
            <div class="elementor-element elementor-element-527cfbd elementor-widget elementor-widget-heading" data-id="527cfbd" data-element_type="widget" id="tp-sm" data-widget_type="heading.default">
        <div class="elementor-widget-container">
      <h2 class="elementor-heading-title elementor-size-default">INTRODUCTION</h2>    </div>
        </div>
        <div class="elementor-element elementor-element-e2bb418 elementor-widget elementor-widget-text-editor" data-id="e2bb418" data-element_type="widget" id="txt-btm" data-widget_type="text-editor.default">
        <div class="elementor-widget-container">
          <div class="elementor-text-editor elementor-clearfix"><p>Corient Business Solutions Limited is registered company in England and Wales registered number 7880941 with office at The Techno Centre, Puma Way, Coventry, CV 1 2TT</p><p>Corient Business Solutions Limited which is a Data Controller and is registered with the Information Commissioner Office (ICO) under reference ZA095945</p><p>Corient Business Solutions Limited (Corient) is strongly committed to protecting personal data. This privacy statement describes why and how we collect and use personal data and provides information about individuals’ rights. It applies to personal data provided to us, both by individuals themselves or by others. We may use personal data provided to us for any of the purposes described in this privacy statement or as otherwise stated at the point of collection.</p><p>We may change this Policy from time to time so please check this page occasionally to ensure that you’re happy with any changes. By using our website, you’re agreeing to be bound by this Policy. Any questions regarding this Policy and our privacy practices should be sent by email to <a href="mailto:info@corientbs.com">info@corientbs.com</a> or by writing to Corient Business Solutions Limited, The Techno Centre, Puma Way, Coventry, CV 1 2TT. Alternatively, you can telephone 02476 103333</p></div>
        </div>
        </div>
        <div class="elementor-element elementor-element-07f6350 elementor-widget elementor-widget-heading" data-id="07f6350" data-element_type="widget" data-widget_type="heading.default">
        <div class="elementor-widget-container">
      <h2 class="elementor-heading-title elementor-size-default">WHAT IS PERSONAL DATA</h2>   </div>
        </div>
        <div class="elementor-element elementor-element-5c18437 elementor-widget elementor-widget-text-editor" data-id="5c18437" data-element_type="widget" data-widget_type="text-editor.default">
        <div class="elementor-widget-container">
          <div class="elementor-text-editor elementor-clearfix"><p>Personal data is any information relating to an identified or identifiable living person.  When “you” or “your” are used in this statement, we are referring to the relevant individual who is the subject of the personal data. Corient processes personal data for numerous purposes, and the means of collection, lawful basis of processing, use, disclosure, and retention periods for each purpose may differ.</p><p>When collecting and using personal data, our policy is to be transparent about why and how we process personal data. To find out more about our specific processing activities, please go to the relevant sections of this statement.</p></div>
        </div>
        </div>
        <div class="elementor-element elementor-element-e60461e elementor-widget elementor-widget-heading" data-id="e60461e" data-element_type="widget" data-widget_type="heading.default">
        <div class="elementor-widget-container">
      <h2 class="elementor-heading-title elementor-size-default">OUR PROCESSING ACTIVITIES</h2>   </div>
        </div>
        <div class="elementor-element elementor-element-8b368dd elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="8b368dd" data-element_type="widget" data-widget_type="icon-list.default">
        <div class="elementor-widget-container">
          <ul class="elementor-icon-list-items">
              <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Potential Clients and Business Contacts</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Our Clients- Individuals, Sole Proprietors, Partnership Firms, LLPs, Limited Companies</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Individuals whose personal data we obtain in connection with providing services to our clients</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Recruitment Applicants</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Our Staff</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Suppliers</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Individuals who use our Applications</span>
                  </li>
            </ul>
        </div>
        </div>
        <div class="elementor-element elementor-element-fd54d69 elementor-widget elementor-widget-heading" data-id="fd54d69" data-element_type="widget" data-widget_type="heading.default">
        <div class="elementor-widget-container">
      <h2 class="elementor-heading-title elementor-size-default">DATA SECURITY</h2>   </div>
        </div>
        <div class="elementor-element elementor-element-3b80706 elementor-widget elementor-widget-text-editor" data-id="3b80706" data-element_type="widget" data-widget_type="text-editor.default">
        <div class="elementor-widget-container">
          <div class="elementor-text-editor elementor-clearfix"><p>We take the security of all the data we hold very seriously. We adhere to internationally recognised security standards and our information security management system relating to client confidential data is independently certified as complying with the requirements of ISO/IEC 27001: 2013. We have a framework of policies, procedures and training in place covering data protection, confidentiality and security and regularly review the appropriateness of the measures we have in place to keep the data we hold secure.</p><p>Security precautions in place to protect the loss, misuse or alteration of your information</p><p><b>All the data is stored within UK having following minimum standards:</b></p></div>
        </div>
        </div>
        <div class="elementor-element elementor-element-380bb17 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="380bb17" data-element_type="widget" data-widget_type="icon-list.default">
        <div class="elementor-widget-container">
          <ul class="elementor-icon-list-items">
              <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">SSAE 16 SOC 1 Type 2 and SOC 2 Type 2 Attestation</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">PCI Data Compliant</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">ISO 27001 Compliant</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">HIPAA and HITECH Compliant</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Virtual Private Network through private IP address ranges</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">256 bit AES Encryption</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Deployment of Anti Malware</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Multi Factor Authentication</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Intrusion detection/Distributed Denial of Service (DDoS) Defense</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Regular Penetration Testing</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Network Isolation</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Virtual Networking</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Automated Scans to identify harmful emails</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Firewalls and other applicable security standards to detect, investigate and eliminate data threats</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Policies and Procedures to monitor usage of data</span>
                  </li>
            </ul>
        </div>
        </div>
        <div class="elementor-element elementor-element-c8570df elementor-widget elementor-widget-heading" data-id="c8570df" data-element_type="widget" data-widget_type="heading.default">
        <div class="elementor-widget-container">
      <h2 class="elementor-heading-title elementor-size-default">THIRD-PARTY SERVICE PROVIDERS WORKING ON OUR BEHALF</h2>   </div>
        </div>
        <div class="elementor-element elementor-element-c9fba7c elementor-widget elementor-widget-text-editor" data-id="c9fba7c" data-element_type="widget" data-widget_type="text-editor.default">
        <div class="elementor-widget-container">
          <div class="elementor-text-editor elementor-clearfix"><p>We may pass your information to our third-party service providers, agents, subcontractors and other associated organisations for the purposes of completing tasks and providing products and / or services to you on our behalf, for example to process payroll, provide bookkeeping services or deliver other specialist services. However, when we use third party service providers, we disclose only the personal information that is necessary to deliver the service and we have a contract in place that requires them to keep your information secure and not to use it for their own purposes.</p><p>We have put in place measures, based upon model contract clauses supplied by the European commission to ensure your personal data is treated by those third parties in a way consistent with and which respects the data protection legislation. The servers powering and facilitating that cloud infrastructure are located in secure data centres in United Kingdom, and personal data may be stored in any one of them.</p><p><b>Further details of these providers are mentioned below:</b></p></div>
        </div>
        </div>
        <section class="elementor-section elementor-inner-section elementor-element elementor-element-45480af elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="45480af" data-element_type="section">
            <div class="elementor-container elementor-column-gap-no">
              <div class="elementor-row">
          <div class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-d157fc1" data-id="d157fc1" data-element_type="column">
      <div class="elementor-column-wrap elementor-element-populated">
              <div class="elementor-widget-wrap">
            <div class="elementor-element elementor-element-1a47eed elementor-widget elementor-widget-heading" data-id="1a47eed" data-element_type="widget" data-widget_type="heading.default">
        <div class="elementor-widget-container">
      <h6 class="elementor-heading-title elementor-size-default">NAME</h6>    </div>
        </div>
        <div class="elementor-element elementor-element-d757d9f elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="d757d9f" data-element_type="widget" data-widget_type="icon-list.default">
        <div class="elementor-widget-container">
          <ul class="elementor-icon-list-items">
              <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Microsoft Limited</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Rackspace Limited</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Xero UK Limited</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Intuit Limited</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Sage (UK) Ltd</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Egenera</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Corient Business Solutions Private Limited</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Mail Chimp</span>
                  </li>
            </ul>
        </div>
        </div>
            </div>
          </div>
    </div>
        <div class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-cf1fe4b" data-id="cf1fe4b" data-element_type="column">
      <div class="elementor-column-wrap elementor-element-populated">
              <div class="elementor-widget-wrap">
            <div class="elementor-element elementor-element-e7250cf elementor-widget elementor-widget-heading" data-id="e7250cf" data-element_type="widget" data-widget_type="heading.default">
        <div class="elementor-widget-container">
      <h6 class="elementor-heading-title elementor-size-default">ROLE</h6>    </div>
        </div>
        <div class="elementor-element elementor-element-6de1e21 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="6de1e21" data-element_type="widget" data-widget_type="icon-list.default">
        <div class="elementor-widget-container">
          <ul class="elementor-icon-list-items">
              <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Azure cloud services, Office 365 and Mail Exchange</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Cloud Services for Data Storage</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Cloud Accounting Application</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Cloud Accounting Application</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Payroll and Cloud Accounting</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Cloud Services for Data Storage</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Processing Services</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">E Mail Management Software for managing Marketing and Newsletter Services</span>
                  </li>
            </ul>
        </div>
        </div>
            </div>
          </div>
    </div>
        <div class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-d48a601" data-id="d48a601" data-element_type="column">
      <div class="elementor-column-wrap elementor-element-populated">
              <div class="elementor-widget-wrap">
            <div class="elementor-element elementor-element-34c83ae elementor-widget elementor-widget-heading" data-id="34c83ae" data-element_type="widget" data-widget_type="heading.default">
        <div class="elementor-widget-container">
      <h6 class="elementor-heading-title elementor-size-default">ADDRESS</h6>   </div>
        </div>
        <div class="elementor-element elementor-element-eddf50a elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="eddf50a" data-element_type="widget" data-widget_type="icon-list.default">
        <div class="elementor-widget-container">
          <ul class="elementor-icon-list-items">
              <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Microsoft Campus, Thames Valley Park, Reading, RG6 1WG, UK</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Hyde Park Hayes, 5 Millington Rd, Hayes UB3 4AZ, UK</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Bank House, 171 Midsummer Blvd, Milton Keynes MK9 1EB</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">1 Cathedral Piazza Victoria, London SW1E 5BP</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">1, Exchange Quay, Salford M5 3EA</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">21 St. Thomas Street Bristol, BS1 6JS United Kingdom</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">101, Sai Sampann, Station Road, Vikhroli East, Mumbai 400083, India</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">c/o The Rocket Science Group, LLC, 675 Ponce De Leon Ave NE Suite 5000, Atlanta, GA 30308 USA</span>
                  </li>
            </ul>
        </div>
        </div>
            </div>
          </div>
    </div>
                </div>
          </div>
    </section>
        <div class="elementor-element elementor-element-68ca080 elementor-widget elementor-widget-text-editor" data-id="68ca080" data-element_type="widget" data-widget_type="text-editor.default">
        <div class="elementor-widget-container">
          <div class="elementor-text-editor elementor-clearfix"><p>As part of the services offered to you, we may send your data outside of the European Economic Area (EEA).  Where this is the case, we will take reasonable steps to ensure that your data is protected in the same way as if it was being used in the EEA.  For example, where third party suppliers store data in the US, we will ensure that their services fall within the Privacy Shield. <a href="https://www.privacyshield.gov/" target="_blank" rel="noopener">https://www.privacyshield.gov</a></p><p>We may use third parties located in other countries to help us run our business. As a result, personal data may be processed outside the countries where we and our clients are located. This includes to countries outside the European Union and to countries that do not have laws that provide specific protection for personal data. We have taken steps to ensure all personal data is provided with adequate protection and that all transfers of personal data outside the EU are done lawfully.</p></div>
        </div>
        </div>
        <div class="elementor-element elementor-element-fc40000 elementor-widget elementor-widget-heading" data-id="fc40000" data-element_type="widget" data-widget_type="heading.default">
        <div class="elementor-widget-container">
      <h2 class="elementor-heading-title elementor-size-default">DATA INSPECTION</h2>   </div>
        </div>
        <div class="elementor-element elementor-element-9ad9a93 elementor-widget elementor-widget-text-editor" data-id="9ad9a93" data-element_type="widget" data-widget_type="text-editor.default">
        <div class="elementor-widget-container">
          <div class="elementor-text-editor elementor-clearfix"><p>We strive to be as open as we can be in terms of giving people access to their personal data. A Subject Access Request under the GDPR is your right to request a copy of the information that we hold about you. Such requests must be in writing to the contact details provided in this policy. If we do hold your personal data we will respond in writing within one calendar month of your request (where that request was submitted in accordance with this policy).</p><p><b>The information we supply will:</b></p></div>
        </div>
        </div>
        <div class="elementor-element elementor-element-a2ee6b3 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="a2ee6b3" data-element_type="widget" data-widget_type="icon-list.default">
        <div class="elementor-widget-container">
          <ul class="elementor-icon-list-items">
              <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">confirm that your data is being processed;</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">verify the lawfulness and the purpose of the processing;</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">confirm the categories of personal data being processed;</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">confirm the type of recipient to whom the personal data have been or will be disclosed, and</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">let you have a copy of the data in an intelligible form.</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">Please note that you may need to provide identification in order to prove who you are to access your data.</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">If you agree, we will try to deal with your request informally, for example by providing you with the specific information you need over the telephone.</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">In the instance that we do not hold information about you we will also confirm this in writing at the earliest opportunity.</span>
                  </li>
            </ul>
        </div>
        </div>
        <div class="elementor-element elementor-element-ba3e787 elementor-widget elementor-widget-heading" data-id="ba3e787" data-element_type="widget" data-widget_type="heading.default">
        <div class="elementor-widget-container">
      <h2 class="elementor-heading-title elementor-size-default">INDIVIDUALS’ RIGHTS AND HOW TO EXERCISE THEM</h2>    </div>
        </div>
        <div class="elementor-element elementor-element-74596b6 elementor-widget elementor-widget-text-editor" data-id="74596b6" data-element_type="widget" data-widget_type="text-editor.default">
        <div class="elementor-widget-container">
          <div class="elementor-text-editor elementor-clearfix"><p>Individuals have certain rights over their personal data and controllers are responsible for fulfilling these rights.</p><p>Individuals’ rights may include the right of access to personal data, to rectification of personal data, to erasure of personal data / right to be forgotten, to restrict processing of personal data, to object to processing of personal data, to data portability, the right to withdraw consent at any time (where processing is based on consent) and the right to lodge a complaint with a supervisory authority.</p><p>Please see further information about these rights, when they are available and how to exercise them below.</p><p><b>Your right of access to personal data</b></p><p>You have the right to obtain confirmation as to whether we process personal data about you, receive a copy of your personal data held by us as a controller and obtain certain other information about how and why we process your personal data (similar to the information provided in this privacy statement). This right may be exercised by emailing us at <a href="mailto:info@corientbs.com">info@corientbs.com</a>. We aim to respond to any requests for information promptly, and in any event within the legally required time limits.</p><p><b>Your right to rectification / amendment of personal data</b></p><p>You have the right to request for your personal data to be amended or rectified where it is inaccurate (for example, if you change your name or address) and to have incomplete personal data completed.</p><p>To update personal data submitted to us, you may email us at <a href="mailto:info@corientbs.com">info@corientbs.com</a> or, where appropriate, contact us via the relevant website registration page or directly amend the personal details held on relevant websites or applications with which you registered.</p><p>When practically possible, once we are informed that any personal data processed by us is no longer accurate, we will make updates as appropriate based on your updated information.</p><p><b>Your right to erasure / right to be forgotten<br />You have the right to obtain deletion of your personal data in the following cases:</b></p></div>
        </div>
        </div>
        <div class="elementor-element elementor-element-2fcd707 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="2fcd707" data-element_type="widget" data-widget_type="icon-list.default">
        <div class="elementor-widget-container">
          <ul class="elementor-icon-list-items">
              <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">the personal data are no longer necessary in relation to the purposes for which they were collected and processed;</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">our legal grounds for processing is consent, you withdraw consent and we have no other lawful basis for the processing;</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">our legal grounds for processing is that the processing is necessary for legitimate interests pursued by us or a third party, you object to our processing and we do not have overriding legitimate grounds;</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">you object to our processing for direct marketing purposes;</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">your personal data have been unlawfully processed; or</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">your personal data must be erased to comply with a legal obligation to which we are subject.</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">To request deletion of your personal data, please email us at info@corientbs.com.</span>
                  </li>
            </ul>
        </div>
        </div>
        <div class="elementor-element elementor-element-ec25633 elementor-widget elementor-widget-text-editor" data-id="ec25633" data-element_type="widget" data-widget_type="text-editor.default">
        <div class="elementor-widget-container">
          <div class="elementor-text-editor elementor-clearfix"><p><b>Your right to restrict processing</b></p><p>You have the right to restrict our processing of your personal data in the following cases:</p></div>
        </div>
        </div>
        <div class="elementor-element elementor-element-b310b16 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="b310b16" data-element_type="widget" data-widget_type="icon-list.default">
        <div class="elementor-widget-container">
          <ul class="elementor-icon-list-items">
              <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">for a period enabling us to verify the accuracy of your personal data where you have contested the accuracy of the personal data;</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">your personal data have been unlawfully processed and you request restriction of processing instead of deletion;</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">your personal data are no longer necessary in relation to the purposes for which they were collected and processed but the personal data are required by you to establish, exercise or defend legal claims; or</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">for a period enabling us to verify whether the legitimate grounds relied on by us override your interests where you have objected to processing based on it being necessary for the pursuit of a legitimate interest identified by us.</span>
                  </li>
                <li class="elementor-icon-list-item">
                      <span class="elementor-icon-list-icon">
              <i aria-hidden="true" class="fas fa-check"></i>           </span>
                    <span class="elementor-icon-list-text">To restrict our processing of your personal data, please email us at info@corientbs.com.</span>
                  </li>
            </ul>
        </div>
        </div>
        <div class="elementor-element elementor-element-0019ef1 elementor-widget elementor-widget-text-editor" data-id="0019ef1" data-element_type="widget" data-widget_type="text-editor.default">
        <div class="elementor-widget-container">
          <div class="elementor-text-editor elementor-clearfix"><p><b>Your right to object to processing<br /></b><br />Where we process personal data based on consent, individuals have a right to withdraw consent at any time.  We do not generally process personal data based on consent (as we can usually rely on another legal basis). Where we rely on your consent for our processing of your personal data, to withdraw your consent please email us at <a href="mailto:info@corientbs.com">info@corientbs.com</a> or, to stop receiving an email from a Corient Marketing list, please click on the unsubscribe link in the relevant email.  Please see the relevant “Use of personal data” sections of this privacy statement for further details about our processing of personal data based on consent.</p></div>
        </div>
        </div>
        <div class="elementor-element elementor-element-9d99a12 elementor-widget elementor-widget-heading" data-id="9d99a12" data-element_type="widget" data-widget_type="heading.default">
        <div class="elementor-widget-container">
      <h2 class="elementor-heading-title elementor-size-default">COMPLAINTS</h2>    </div>
        </div>
        <div class="elementor-element elementor-element-c6a92d9 elementor-widget elementor-widget-text-editor" data-id="c6a92d9" data-element_type="widget" data-widget_type="text-editor.default">
        <div class="elementor-widget-container">
          <div class="elementor-text-editor elementor-clearfix"><p>Please send an email with the details of your complaint to <a href="mailto:info@corientbs.com">info@corientbs.com</a>. We will look into and respond to any complaints we receive.</p><p>You also have the right to lodge a complaint with the supervisory authority in your country of residence, place of work or the country in which an alleged infringement of data protection law has occurred within the EU. The Information Commissioner’s Office (“ICO”) is the UK data protection regulator/supervisory authority. For further information on your rights and how to complain to the ICO, please refer to the ICO website.</p></div>
        </div>
        </div>
            </div>
          </div>
    </div>
                </div>
          </div>
    </section>       
      </div>

    </Main>
  </div>
</template>
<script>
import { Main, TableWrapper } from "/src/view/styled.js";
import { computed, ref, defineComponent, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { UserTableStyleWrapper, Action, ProductCard } from "./style";
import * as FontAwesomeIcon from "@fortawesome/free-solid-svg-icons";
import Modal from "/src/components/Modal.vue";
export default defineComponent({
  name: "dashboard",
  components: {
    Main,
    TableWrapper,
    UserTableStyleWrapper,
    Modal,
    ProductCard,
    FontAwesomeIcon,
    Action,
  },
 
  setup() {
    let empty = ref(true);
    let loading = ref(true);
    let orgdata = ref(null);
    let showModal= ref(false);
    let reconnect=ref(false);
    const param = useRoute();
    const router = useRouter();
    const { state, dispatch } = useStore();
    const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;
    onMounted(() => {
      xerocheck();
    });
    var ten_id="";
    const openModal = (tenent_id,output) => {
    ten_id=tenent_id;
    var out=output;
    //alert(tenent_id);
    localStorage.setItem("ten_id", ten_id);
    localStorage.setItem("output", out);
    showModal.value=true;
    }
    const xerocheck = () => {
      if (param.params.id) {
        dispatch("xerosave", param.params.id.toString()).then(
          (response) => {
            router.push("/");
          },
          (error) => {
            // console.log(error);
            empty.value = true;
          }
        );
        empty.value=false;
        loading.value = false;
      } else {
        dispatch("getclientlist").then(
          (response) => {
            state.xeroclient.data = response.data;
            empty.value = false;
            loading.value = false;
          },
          (error) => {
            // console.log(error);
            empty.value = false;
            loading.value = false;
          }
        );
        
      }
    };

    const xerodisconnect = (tenent_id) => {
      dispatch("xerodisconnect",tenent_id).then(
        (response) => {
        location.reload(true);
          xerocheck();
        },
        (error) => {
        //window.location.reload(true);
          xerocheck();
          // console.log(error);
        }
      );
    };

    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        selectedRowKeys.value = selectedRowKeys;
        selectedRows.value = selectedRows;
      },
      getCheckboxProps: (record) => ({
        disabled: record.name === "Disabled User",
        name: record.name,
      }),
    };

    const showEditModal = (data) => {
      console.log(data);
    };

    const onHandleDelete = (id) => {
      console.log(id);
    };

    const handlesort = () => {
      var data = {};
      dispatch("clientdatasort", data);
    };

    const overviewpage = (id) => {
      if (id !== undefined) {
        localStorage.setItem("org", id);
        router.push({ path: "/overview" });
      }
    };
    const startactive = (id, tenent_id) => {
      console.log(id);
      dispatch("onStarUpdate", { id: id, tenent_id: tenent_id }).then(
        (response) => {
          xerocheck();
        },
        (error) => {
          // console.log(error);
          empty.value = true;
        }
      );
    };
    var usersTableData = computed(() => state.xeroclient.data);

    const xeroconnect = () => {
      window.location.href = API_ENDPOINT + "xero/authorization.php?app_id=1";
    };

     const xeroResync = (tenent_id) => {

      dispatch("getResync",tenent_id).then(
        (response) => {
          location.reload()
        },
        (error) => {}
      );
    };
 const xeroreconnect = (tenent_id) => {
     dispatch("xerorefresh",tenent_id).then(
        (response) => {
        //location.reload(true);
        xerocheck();
        },
        (error) => {
        //window.location.reload(true);
          xerocheck();
          // console.log(error);
        }
      ); 
    };


    return {
      rowSelection,
      empty,
      usersTableData,
      showEditModal,
      showModal,
      openModal,
      orgdata,
      handlesort,
      startactive,
      overviewpage,
      xerodisconnect,
      xeroconnect,
      xeroreconnect,
      loading,
      xeroResync
    };
  },
});
</script>
<style>
.ant-list-items {
  padding-top: 0px !important;
}

.highlighted {
  margin: 10px !important;
  border-spacing: 0 8px !important;
}

.product-list:hover {
  -webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
.hentry .entry-content {
    margin-bottom: 0em;
}
.aux-logo-text .site-title {
    font-size: 2.2em;
    color: #fff;
/*    color: #aac03a; */
}

.aux-logo-text .site-title {
    line-height: 150%;
}

#elementor-tab-title-2091{
  visibility:hidden;
}

element.style {
    top: 32px;
}
.aux-top-sticky .site-header-section.aux-sticky {
    position: fixed;
    top: 0;
    width: 100%;
    box-shadow: 0 4px 0 rgb(34 34 34 / 3%);
    z-index: 1400;
}
.site-header-section.aux-sticky {
    background-color: #fbfbfb;
}
.aux-top-header {
    background: linear-gradient(126deg, rgb(12 123 80) 26%, rgb(96 159 70) 74%, rgb(155 185 61) 88%) !important;
}

div#top-header  {
     background: linear-gradient(126deg, rgb(12 123 80) 26%, rgb(96 159 70) 74%, rgb(155 185 61) 88%) !important;
  border-bottom: none !important;
}

.aux-social-list li {
    margin: 4px;
}

.hit-tab .elementor-widget-container .elementor-text-editor ul li {
    list-style: disc;
}

.hit-tab .elementor-tabs-content-wrapper .elementor-tab-content ul li {
    list-style: disc;
} 

.elementor-widget-tabs .elementor-tab-content {
    padding: 20px 10px !important;
}

.aux-site-footer {
    padding: 0px;
    color: #fff;
}
.aux-site-footer small {
    font-weight: 500;
}

.wpcf7 input[type="submit"] {
    width: 100%;
}

input[type="submit"] {
    background-color: #007aff;
}

input[type="submit"]:hover {
    background-color: #0092FF;
}

.wpcf7 input[type="text"], .wpcf7 input[type="email"], .wpcf7 input[type="tel"], .wpcf7 textarea {
    margin-bottom: 0em;
    background: #fff;
    height: 35px;
    font-size: 14px;
    padding: .5375em;
}

span.small-tab {
  color: #000;
  font-size: 13px;
  font-weight: 400;
}

.elementor-8 .elementor-element.elementor-element-a62e4e2 .elementor-tab-title {
    opacity: 0.3;
  border-right: 1px solid;
      padding: 30px;
      margin: 5px;

}
.elementor-8 .elementor-element.elementor-element-a62e4e2 .elementor-tab-title:last-child {
    opacity: 0.3;
    border-bottom: none;
}
.elementor-8 .elementor-element.elementor-element-a62e4e2 .elementor-tab-title:hover {
    opacity: 0.7;
}
.elementor-8 .elementor-element.elementor-element-a62e4e2 .elementor-tab-desktop-title.elementor-active {
    opacity: 1;
}
.elementor-widget-tabs .elementor-tab-desktop-title {
    padding: 20px 0px;
}
/*************************/


.elementor-8 .elementor-element.elementor-element-a62e4e2 .elementor-tab-desktop-title.elementor-active {
    background-color: transparent;
  
      box-shadow: 1px 0px 7px 0px #babdcb;
  
}

/* .site-header-section {
    background: linear-gradient(126deg, rgb(3 135 230) 26%, rgb(3 135 230) 74%, rgb(27 148 233) 80%); 
}*/
    
.site-header-section.aux-add-border .aux-wrapper {
    border-bottom: #0188e6;
}
.site-header-section .aux-menu-depth-0>.aux-item-content {
    display: block;
 padding: 34px 1.3125em;
    font-size: 14px;
/*     color: #ffffff; */
    font-weight: 600;
    text-transform: uppercase;
    white-space: nowrap;
}
span.ct {
    color: white;
    font-size: 17px;
  margin-left: 5px;
}
span.ph {
    margin-left: 5px;
    color: white;
  font-size: 17px;
}
i.fa.fa-phone {
    margin-left: 39px;
    color: #ffffff; 
}
i.fa.fa-envelope {
    color: white;
}
.aux-search-section.aux-end.aux-middle.aux-phone-off {
    display: none;
}
.aux-top-header .aux-social-list a {
    color: #ffffff;
    padding: 6px 6px;
    border: 2px solid #ffff;
    border-radius: 17px;
    padding-left: 7px;
    padding-right: 6px;
}
rs-layer#slider-1-slide-1-layer-2 {
/*     background-color: #ff232300 !important; */
    border: 2px solid #fff !important;
    border-radius: 30px !important;
}
rs-layer#slider-1-slide-1-layer-3 {
/*   background-color: #ff232300 !important; */
    border: 2px solid #fff !important;
    border-radius: 30px !important;
}

rs-layer#slider-1-slide-3-layer-2 {
/*   background-color: #ff232300 !important; */
    border: 2px solid #fff !important;
    border-radius: 30px !important;
}

rs-layer#slider-1-slide-3-layer-3 {
/*  background-color: #ff232300 !important; */
    border: 2px solid #fff !important;
    border-radius: 30px !important;
}

input[type="submit"] {
    background-color: #0567b2;
}

/* .elementor-8 .elementor-element.elementor-element-a62e4e2 .elementor-tab-title {
    border: 1px solid #eadbdb;
    padding: 30px 18px;
} */

.aux-top-sticky .site-header-section.aux-sticky .aux-wrapper {
    border-bottom: none;
}

/* .site-header-section .aux-menu-depth-0>.aux-item-content {
    color: #ffffff;
} */

/*** Custom css Saud ***/

@media screen and (max-width: 767px){
  #sm-padding{
    padding:0px 30px;;
  }
  #tp-sm{
    margin-top:15px;
  }
  #txt-btm{
    margin-bottom:10px;
  }
}

#pb-0{
  margin-bottom:0!important;
}
.wpcf7-form-control-wrap {
    position: initial;
}
.your-email{
  margin-bottom:10px;
}
.elementor-icon-box-wrapper{
  
}
#rt-tpg-container-2069283440 .rt-detail h2.entry-title a:hover, #rt-tpg-container-2069283440 .rt-detail h3.entry-title a:hover, #rt-tpg-container-2069283440 .rt-detail h4.entry-title a:hover{
  color: #000!important;
}
.rt-detail .post-content{
      font-size: 14px;
    font-family: 'Roboto';
}
.rt-detail h2.entry-title{
    font-size: 20px!important;
    font-family: 'Roboto';
}
.wpcf7 textarea{
  min-height: 130px!important;
}
.subfooter.aux-dark .widget-title{
     color: #0567B2;
    font-weight: 700;
    margin-bottom: 20px;
}
.widget-container a{
    color: #000;
    display: inline-block;
    margin-bottom: 0px;
}
.textwidget{
  color:#000;
}
.widget-container a:hover{
  color:#000;
}
aside .widget-title{
    color: #0567B2!important;
    font-weight: 700!important;
    font-size: 20px;
    border-bottom: none;
    margin-bottom: 20px;
    padding-bottom:0!important;
}
.widget-container a {
    font-size: 15px;
}
#text-8{
      margin-top: 18px;
      font-size: 15px;
  color:#000;
}
.subfooter .aux-fold{
      padding: 40px 40px 40px 40px!important;
  margin-bottom:0px!important;
}

.rt-holder {
    box-shadow: 0 0 10px #00000050;
    border-radius: 5px;
}
.rt-tpg-container .layout1 .rt-holder .rt-detail {
    background: #fff;
    padding: 15px 15px;
}
.entry-content iframe {
    margin-bottom: 0em;
}

@media screen and (max-width: 430px){
.elementor-tab-title.elementor-tab-mobile-title.elementor-active {
    opacity: 1 !important;
}
.hit-tab .elementor-widget-container .elementor-text-editor ul li {
    list-style: inside;
}
.site-header-section.aux-header-light .aux-burger-box .aux-burger:after, .site-header-section.aux-header-light .aux-burger-box .aux-burger:before, .site-header-section.aux-header-light .aux-burger-box .aux-burger .mid-line {
    border-color: #0567B2;
}
}
@media screen and (max-width: 375px){
.aux-float-layout .aux-center-middle {
    left: 40%;
}
}
@media screen and (max-width: 479px) {
.site-header-section {
      background-color: #b8c1c7;
}
.site-header-section {
      background: #b8c1c7 !important;
}
.site-header-section.aux-sticky {
    background-color: #fbfbfb !important;
}
.aux-resp .widget-title {
    text-align: left;
}
}
@media screen and (max-width: 430px) {
.elementor-635 .elementor-element.elementor-element-c7864e7 .elementor-tab-title {
    background: #002449;
}
.elementor-635 .elementor-element.elementor-element-c7864e7 .elementor-tab-title:active {
    background: #46C7FF;
}
}
@media screen and (min-width: 767px){
  .offer_section .elementor-widget-container, .offer_section  .elementor-element{height:100%;}

}
.elementor-widget-tabs.elementor-tabs-view-horizontal .elementor-tab-desktop-title.elementor-active {
    background: #46C7FF;
}
/*
.elementor-widget-tabs.elementor-tabs-view-horizontal .elementor-tab-desktop-title {
    display: block;
    width: 50%;
    float: left;
  background: #002449;
  
}*/
.elementor-tabs .elementor-tabs-wrapper {
  padding-bottom: 20px;
}
.elementor-tab-title {
  text-align: center;
}

div#elementor-tab-title-2092 {
    width: 158px;
    margin-left: 2px;
}
div#elementor-tab-title-2091 {
    width: 158px;
    margin-left: 489px;
}
@media screen and (max-width: 768px) {div#elementor-tab-title-2091 {
    width: 158px;
    margin-left: 214px;
  }}

@media screen and (max-width: 768px) {div#elementor-tab-title-2092 {
    width: 158px;
    margin-left: 2px;
  }}
@media screen and (max-width: 1024px) {div#elementor-tab-title-2091 {
    width: 158px !important;
    margin-left: 332px !important;
}}
@media screen and (max-width: 1024px) {div#elementor-tab-title-2092 {
    width: 158px !important;
    margin-left: 2px !important;
  }}

/****** user register ******/
.woocommerce button.button, .woocommerce a.button {
    color: #fff;
    background-color: #0567b2;
    padding: 0.8em 3em;
    font-weight: 500;
    border-radius: 0px;
}
.woocommerce button.button:hover, .woocommerce a.button:hover {
    color: #fff;
    background-color: #0092FF;
}
form.woocommerce-form p {
  font-family: "Roboto", Sans-serif;
  color: #000;
  font-size: 14px;
}
form.woocommerce-form label {
    margin-bottom: 0em;
}
form.woocommerce-form p a {
    color: #0567b2;
}
form.woocommerce-form input[type="text"], form.woocommerce-form input[type="password"], form.woocommerce-form input[type="email"] {
    padding: 0.6em;
    max-width: 100%;
}
.woocommerce form.login, .woocommerce form.register {
    margin: 1em 0;
}
.entry-content h2 {
    color: #0567b2;
    font-weight: 400;
}
nav.woocommerce-MyAccount-navigation ul li {
    border-bottom: 2px solid #0092FF;
    background: #fbfbfb;
    width: 70%;
    margin-bottom: 10px;
}
nav.woocommerce-MyAccount-navigation a {
    color: #0567b2;
}
::marker {
    color: #0567b2;
}
.woocommerce-MyAccount-content a {
    color: #0567b2;
}
tr.woocommerce-cart-form__cart-item.cart_item a {
    color: #0567b2; 
}
.woocommerce button.button:disabled, .woocommerce button.button:disabled[disabled] {
    color: #fff;
}
.woocommerce a.button.alt, .woocommerce button.button.alt {
    background-color: #0567b2;
}
.woocommerce a.button.alt:hover, .woocommerce button.button.alt:hover {
    background-color: #0092FF;
}
a.woocommerce-privacy-policy-link {
    color: #0567b2; 
}
.woocommerce-billing-fields label {
    margin-bottom: 0em;
    font-family: "Roboto", Sans-serif;
    font-size: 14px;
}
.woocommerce-billing-fields input[type="text"], .woocommerce-billing-fields input[type="password"], .woocommerce-billing-fields input[type="email"], .woocommerce-billing-fields input[type="tel"], .woocommerce-additional-fields__field-wrapper textarea {
    padding: 0.5em;
    font-size: 14px;
    max-width: 100%;
}
.woocommerce form .form-row textarea {
    height: 10em;
}
#order_comments_field label {
    margin-bottom: 0em; 
}
.select2-container--default .select2-selection--single {
    border-radius: 0px;
}
.select2-container .select2-selection--single {
    height: 36px;
}
.select2-container--default .select2-selection--single .select2-selection__rendered {
    line-height: 36px;
    font-size: 14px;
}
.select2-container--default .select2-selection--single .select2-selection__arrow {
    height: 36px;
}
td.woocommerce-table__product-name.product-name a {
    color: #0567b2;   
}

.page-title-section .page-header {
    min-height: 360px;
}
.page-title-section .page-header>.aux-container {
    line-height: 150px;
}
.page-title {
    margin-top: 8%;
    font-size: 3em;
    font-weight: 800 !important;
    width: 80%;
    line-height: 50px;
}
.aux-meida-bg-holder.aux-video-box.aux-parallax {
    background-size: cover !important;
}

section#search-2 form#searchform input[type="text"] {
    padding: 0.4em;
}
.single-post .hentry footer.entry-meta .entry-tax {
    margin: 1.125em 0;
}
.single-post .hentry .entry-meta {
    min-height: 90px;
}
.single-post .hentry footer.entry-meta .entry-tax {
    margin: 2.125em 0;
}
.hentry .entry-main {
    margin-bottom: 2.375em;
}
.aux-next-prev-posts {
    margin-bottom: 2.375em;
}
#commentform textarea {
    min-height: 150px;
    height: 150px;
}
.wpcf7 form.invalid .wpcf7-response-output, .wpcf7 form.unaccepted .wpcf7-response-output {
    color: #fff;
}
.site-header-section {
    background-color: #575757 !important;
}
rs-fullwidth-wrap#rev_slider_1_1_forcefullwidth {
    margin-top: 85px !important;
}
span.aux-menu-label:visited  {
    border-bottom: 6px solid #e6be1e;
    height: 50px;
}
/*
span.aux-menu-label:active  {
    border-bottom: 6px solid #e6be1e !important;
    height: 50px;
}*/

.site-header-section .aux-menu-depth-0 > .aux-item-content, .aux-elementor-header-menu .aux-menu-depth-0 > .aux-item-content {
    color: #ffffff!important;
}


.current-menu-item{
    border-bottom: 5px solid #e6be1e !important;
    height: 78px;
    
}
.contact_btn a span{
    background: #e6be1e;
    padding: 6px 15px;
    border-radius: 20px;
    margin-top: -5px;
}
.ff{
      border-bottom:0px !important;
    height: auto!important;
}
#know_more{
font-family: "Roboto", Sans-serif;
    font-size: 17px;
    font-weight: 500;
    fill: #424242;
    color: #424242!important;
    background-color: #E6BE1E!important;
    border-radius: 33px 33px 33px 33px;
    padding: 15px 36px 15px 36px;
}

.landing_form select, .landing_form input, .landing_form input:not(input[type='submit']) {
    width: 100% !important;
    padding: 8px 8px !important;
    height: auto !important;
}
.landing_form label span {
    font-size: 14px;
    color: rgb(142, 145, 152);
}
.landing_form .wpcf7-form-control.wpcf7-submit {
    padding: 18px 0 !important;
}
.landing_form .wpcf7-not-valid-tip {
    color: #f23f3f !important;
}
.landing_form .wpcf7-response-output {
    color: #000 !important;
    margin-top: 0 !important;
}
.landing_form label {
    font-size: 16px;
}
.page-id-1635 header#site-header {
    display: none;
}/* header-logo-width 
=========================*/
.aux-logo-header .aux-logo-anchor{ max-width:120px; }
/* header-logo-max-height-type 
=========================*/
.aux-logo-header .aux-logo-anchor > img { max-height:85px; }
/* site-body-background-pattern 
=========================*/
body:before { height:100%; background-image:url(); }
/* site-body-background-size 
=========================*/
body { background-size:auto; }
/* site-body-background-repeat 
=========================*/
body { background-repeat:no-repeat; }
/* site-body-background-position 
=========================*/
body { background-position:left top; }
/* site-body-background-attach 
=========================*/
body { background-attachment:scroll; }
/* site-frame-background-color 
=========================*/
@media screen and (min-width: 700px) { .aux-framed .aux-side-frames, body.aux-framed:after, .aux-framed .aux-side-frames:before, .aux-framed .aux-side-frames:after {background-color:#111111;}}
/* site-header-container-height 
=========================*/
.site-header-section .aux-header-elements:not(.aux-vertical-menu-elements), .site-header-section .aux-fill .aux-menu-depth-0 > .aux-item-content { height:85px; }
/* site-transparent-header-bgcolor 
=========================*/
.site-header-section { background-color:rgba(0, 0, 0, 0); }
/* site-header-container-scaled-height 
=========================*/
.aux-top-sticky .site-header-section.aux-sticky .aux-fill .aux-menu-depth-0 > .aux-item-content, .aux-top-sticky .site-header-section.aux-sticky .aux-header-elements,.aux-elementor-header.aux-sticky .elementor-section-wrap > .elementor-section > .elementor-container { min-height:80px; }
/* sticky-header-color 
=========================*/
.aux-elementor-header.aux-sticky .elementor-section-wrap > .elementor-section { background-color:#fbfbfb !important; }
/* site-vertical-menu-background-color 
=========================*/
.aux-vertical-menu-side { background-color:#FFF; }
/* site-header-navigation-item-height 
=========================*/
.site-header-section .aux-middle .aux-menu-depth-0 > .aux-item-content { height:60px; }
/* site-mobile-header-toggle-button-color 
=========================*/
.site-header-section .aux-header .aux-burger:before, .site-header-section .aux-header .aux-burger:after, .site-header-section .aux-header .aux-burger .mid-line { border-color:#0567b2; }
/* site-menu-full-screen-background-color 
=========================*/
#fs-menu-search:before { background-color:rgba(255, 255, 255, 0.95); }
/* site-top-header-background-color 
=========================*/
#top-header {background-color:rgba(0, 0, 0, 0);}
/* post-title-bar-overlay-pattern-opacity 
=========================*/
.single-post .aux-overlay-bg-hash::before { opacity:0.15; }
/* page-title-bar-overlay-pattern-opacity 
=========================*/
.page .aux-overlay-bg-hash::before { opacity:0.5; }
/* subfooter-bar-layout-bg-color 
=========================*/
.aux-subfooter-bar { background-color:#fafafa; }
/* subfooter-bar-top-border-color 
=========================*/
.aux-subfooter-bar { border-top:1px solid #EAEAEA; }
/* site-footer-bg-color 
=========================*/
.aux-site-footer {background-color:#1A1A1A;}
/* footer-top-border-color 
=========================*/
.aux-site-footer {border-top:1px solid #000000;}
/* content-typography 
=========================*/
body { font-family: "Poppins";font-weight: regular; }
/* main-title-typography 
=========================*/
h1, h2, h3, h4, h2, h6, .aux-h1, .aux-h2, .aux-h3, .aux-h4, .aux-h2, .aux-h6 { font-family: "Poppins";font-weight: 300; }
/* page-title-typography 
=========================*/
.page-title { font-family: "Raleway";font-weight: 300; }
/* header-menu-typography 
=========================*/
.aux-master-menu { font-family: "Poppins";font-weight: regular; }
/* subfooter-layout-bg-color 
=========================*/
.aux-subfooter { background-color:#fbfbfb; }
/* subfooter-top-border-color 
=========================*/
.aux-subfooter { border-top:1px solid #fbfbfb; }
/* buttons-typography 
=========================*/
.aux-button { font-family: "Raleway";font-weight: regular; }
/* blog-post-share-button-icon-size 
=========================*/
.single-post .aux-single-post-share span::before { font-size:10px; }
/* subfooter-layout-bg-image-position 
=========================*/
.aux-subfooter {background-position:center center;}
/* subfooter-layout-bg-image-size 
=========================*/
.aux-subfooter {background-size:cover;}
/* subfooter-layout-bg-image-repeat 
=========================*/
.aux-subfooter {background-repeat:no-repeat;}
/* footer-top-border-width 
=========================*/
.aux-site-footer { border-top-width:1px; }
.elementor-921 .elementor-element.elementor-element-9d99a12 .elementor-heading-title {
    color: #0567B2 !important;
    font-weight: 800  !important;
    line-height: 1.2em  !important;
}
</style>